<ndt-extension-detail-view
   [extension]="extension$ | async"
   [hackedFraudDetails]="hackedFraudDetails$ | async"
   [extensionPrivileges]="extensionPrivileges$ | async"
   [phonePrivileges]="phonePrivileges$ | async"
   [promptPrivileges]="promptPrivileges$ | async"
   [departmentPrivileges]="departmentPrivileges$ | async"
   [callDetailsPrivileges]="callDetailsPrivileges$ | async"
   [selectedAccountName]="selectedAccount$ | async"
   [isOnSystemPage]="isOnSystemPage$ | async"
   [isSystemUser]="isSystemUser$ | async"
   [callState]="callState$ | async"
   [extensionNumbers]="extensionNumbers$ | async"
   [externalNumbers]="externalNumbers$ | async"
   [idsFromRegister]="idsFromRegister$ | async"
   [totalCount]="totalCount$ | async"
   (formSaveCanceled)="onFormSaveCanceled()"
   (formSubmitted)="onFormSubmitted($event)"
   (deleteExtension)="onDeleteExtension($event)"
   (addExistingPrompt)="onAddExistingPrompt($event)"
   (addNewPrompt)="onAddNewPrompt($event)"
   (addNewTimeBasedRoute)="onAddNewTimeBasedRoute()"
   (addNewFindMeFollowMeStep)="onAddNewFindMeFollowMeStep()"
   (editMailboxPin)="onEditMailboxPin($event)"
   (resetHackedAndFraud)="onResetHackedAndFraud($event)"
   (resetMwi)="onResetMwi($event)"
   (clearMailboxClick)="onClearMailbox($event)"
   (resetMailboxClick)="onResetMailbox($event)"
   (changeDNDStatus)="onChangeDNDStatus($event)"
   (navigateDown)="onNavigate($event)"
   (navigateUp)="onNavigate($event)"
   (loadIdPage)="onLoadIdPage()"
></ndt-extension-detail-view>
